import { Component, Element, h, Host, Prop } from '@stencil/core';
import { getStore } from '../uui-context/uui-context';
import {
  getThemeName,
  getThemeNames,
  makeThemeable,
  setTheme
} from './uui-theme';

@Component({
  tag: 'uui-theme-selector',
  styleUrl: '../uui-select/uui-select.css',
  shadow: true
})
export class UUIThemeSelector {
  _target?: HTMLElement;
  @Element() el: HTMLElement;
  @Prop({ reflect: true, attribute: 'target' }) targetId?: string;
  @Prop() activeTheme;

  state = getStore();

  constructor() {
    makeThemeable(this, () => this.el);
  }

  connectedCallback() {
    if (this.targetId) {
      this._target = document.getElementById(this.targetId);
    }
  }

  changeTheme({ target }) {
    const newTheme = target?.value;
    if (newTheme) {
      this.activeTheme = newTheme;
      setTheme(newTheme, this._target);
    }
  }

  render() {
    const options = [];
    const activeTheme = getThemeName(this.el);
    const themeNames = getThemeNames();
    for (const themeName of themeNames) {
      options.push(
        <option value={themeName} selected={themeName === activeTheme}>
          {themeName}
        </option>
      );
    }
    return (
      <Host>
        <select onChange={this.changeTheme.bind(this)}>{options}</select>
      </Host>
    );
  }
}
